export default function Table({ title, rows = [], columns }) {
  return (
    <section className="panel">
      <h2>{title}</h2>
      {!rows.length ? <div className="empty">No records yet.</div> : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>{columns.map((column) => <th key={column}>{column.replaceAll('_', ' ')}</th>)}</tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id || row.uuid}>
                  {columns.map((column) => <td key={column}>{row[column] || '-'}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
